import { useEffect, useState } from 'react';

/**
 * Delays a value until it stops changing.
 * Mainly for search fields: without it, every keystroke is a request.
 */
export function useDebounce<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebounced(value);
    }, delayMs);
    // Clearing on every change is what makes it a debounce rather than a delay.
    return () => {
      clearTimeout(timer);
    };
  }, [value, delayMs]);

  return debounced;
}
